import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineMaintenanceCreateApi extends BaseClient {
  public doMachineMaintenanceCreate (bodyData: {[key:string]: string|number|string[]}) {
    const path:string = '/v1/machine-maintenances'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new MachineMaintenanceCreateApi()
